
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('password');
  const passwordConfirm = control.get('passwordConfirm');

  if (!password || !passwordConfirm || password.value === passwordConfirm.value) {
    return null; // Passwords match or controls are not found
  }
  return { 'passwordMismatch': true }; // Passwords do not match
};
